import { TeContainer, TeContainerSlim } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';
import { PlaceholderContainer } from '@topcon/topcon-utils';

import { Section } from '../../utils/styling';
import ViewContainer from '../../components/ViewContainer';
import CompanyTree from '../../components/Company/CompanyTree';
import { useIdentityCurrentRequests } from './companies.queries';
import {
  BusinessPartnerWithCurrentIdentityInfoBody,
  RequestToJoinBody,
} from '../../api/generated/pap';

function JoinRequests() {
  const { t } = useTranslation('companies', { keyPrefix: 'joinRequests' });
  const { data: requestsToJoin, isLoading, refetch } = useIdentityCurrentRequests();

  const companies = requestsToJoin?.items
    ?.sort((a, b) =>
      (a.businessPartner?.name ?? '').localeCompare(b.businessPartner?.name ?? '', 'fi', {
        numeric: true,
      })
    )
    .map(
      (requestToJoin: RequestToJoinBody): Partial<BusinessPartnerWithCurrentIdentityInfoBody> => {
        return {
          id: requestToJoin.businessPartner?.id,
          name: requestToJoin.businessPartner?.name ?? '',
          iconURL: requestToJoin.businessPartner?.iconURL,
          requestToJoin: {
            id: requestToJoin.id,
            identityId: requestToJoin.identityId,
          } as RequestToJoinBody,
        };
      }
    );

  const requestsCount = requestsToJoin?.items.length;
  const noContent = isLoading || !requestsToJoin?.items.length;

  const renderLoader = () => {
    return <PlaceholderContainer hasLoader text={t('loadingJoinRequests')} />;
  };

  const renderNoJoinRequests = () => {
    return <PlaceholderContainer grow icon="person_add_alt" text={t('noJoinRequests')} />;
  };

  const renderNoContent = () => {
    return (
      <TeContainerSlim
        backgroundColor="background.secondary"
        borderRadius={4}
        column
        fill
        justifyContent="center"
        alignItems="center"
      >
        {isLoading ? renderLoader() : renderNoJoinRequests()}
      </TeContainerSlim>
    );
  };

  return (
    <TeContainerSlim column grow padding="xs" overflow="auto" alignItems="center">
      <Section>
        <ViewContainer title={t('title')} visibleItemsCount={requestsCount} noPadding noSeparator>
          <TeContainer
            backgroundColor="background.primary"
            overflow="hidden"
            borderRadius={4}
            fill
            column
          >
            {noContent ? (
              renderNoContent()
            ) : (
              <CompanyTree type="requestToJoin" companies={companies || []} onUpdate={refetch} />
            )}
          </TeContainer>
        </ViewContainer>
      </Section>
    </TeContainerSlim>
  );
}

export default JoinRequests;
